var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 4.9401H9.33317V3.60677C9.33317 1.76677 7.83984 0.273438 5.99984 0.273438C4.15984 0.273438 2.6665 1.76677 2.6665 3.60677V4.9401H1.99984C1.2665 4.9401 0.666504 5.5401 0.666504 6.27344V12.9401C0.666504 13.6734 1.2665 14.2734 1.99984 14.2734H9.99984C10.7332 14.2734 11.3332 13.6734 11.3332 12.9401V6.27344C11.3332 5.5401 10.7332 4.9401 9.99984 4.9401ZM5.99984 10.9401C5.2665 10.9401 4.6665 10.3401 4.6665 9.60677C4.6665 8.87344 5.2665 8.27344 5.99984 8.27344C6.73317 8.27344 7.33317 8.87344 7.33317 9.60677C7.33317 10.3401 6.73317 10.9401 5.99984 10.9401ZM8.0665 4.9401H3.93317V3.60677C3.93317 2.46677 4.85984 1.5401 5.99984 1.5401C7.13984 1.5401 8.0665 2.46677 8.0665 3.60677V4.9401Z",
    fill: "#2D96B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/LockIcon.fec7c04d.svg";
export { ForwardRef as ReactComponent };